import { observer } from "mobx-react";
import { useStores } from "../../stores";
import { useEffect } from "react";
import { HEADER_TYPE } from "../../constants";
import { Helmet } from "react-helmet-async";
import * as React from "react";
import { ContactPageContainer, Container, Title } from "../ContactPage/ContactPage.styled";
import { Content } from "../UserAgreementPage/UserAgreementPage.styled";

interface PrivacyPolicyPageProps {}

export const PrivacyPolicyPage = observer(({}: PrivacyPolicyPageProps) => {
	const { settingsStore } = useStores();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
		settingsStore.showFooter();
	}, []);

	return (
		<>
			<Helmet>
				<title>Privacy Policy | MUSICABINET</title>
				<meta name="description" content="" />
			</Helmet>

			<ContactPageContainer>
				{settingsStore.lang === "ru" && (
					<Container>
						<Title>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</Title>

						<p>
							Настоящая политика составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О
							персональных данных» (далее – Закон о персональных данных) и определяет порядок обработки персональных
							данных и меры по обеспечению безопасности персональных данных, предпринимаемые Обществом с ограниченной
							ответственностью «Мьюзикабинет», ОГРН 1171690087337, ИНН 1660299477 (далее – Оператор).
						</p>
						<p>
							Политика конфиденциальности опубликована в соответствии с пунктом 2 статьи 18.1 Федерального закона от
							27.07.2006 N 152-ФЗ «О персональных данных» (далее – «Закон о персональных данных»).
						</p>
						<p>
							Пожалуйста, ознакомьтесь с настоящей Политикой конфиденциальности, прежде чем предоставить нам Ваши
							персональные данные и, чтобы понять, как мы обрабатываем Ваши персональные данные после того, как получаем
							их от Вас, и прежде чем предоставить нам Ваши персональные данные.
						</p>
						<p>
							Мы оставляем за собой право в любое время вносить изменения в Политику конфиденциальности. Дата последних
							изменений будет отображаться на этой странице.
						</p>

						<h4>ОПРЕДЕЛЕНИЕ ТЕРМИНОВ</h4>

						<p>1.1. В настоящей Политике конфиденциальности используются следующие термины:</p>
						<p>
							1.1.1. Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств
							вычислительной техники;
						</p>
						<p>
							1.1.2. Блокирование персональных данных – временное прекращение обработки персональных данных (за
							исключением случаев, если обработка необходима для уточнения персональных данных);
						</p>
						<p>
							1.1.3. Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ и баз
							данных, обеспечивающих их доступность в сети интернет по сетевому адресу https://musicabinet.com;
						</p>
						<p>
							1.1.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных
							данных, и обеспечивающих их обработку информационных технологий и технических средств;
						</p>
						<p>
							1.1.5. Обезличивание персональных данных — действия, в результате которых невозможно определить без
							использования дополнительной информации принадлежность персональных данных конкретному Пользователю или
							иному субъекту персональных данных;
						</p>
						<p>
							1.1.6. Обработка персональных данных – любое действие (операция) или совокупность действий (операций),
							совершаемых с использованием средств автоматизации или без использования таких средств с персональными
							данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
							извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание,
							блокирование, удаление, уничтожение персональных данных. Обработка персональных данных включает в себя в
							том числе:
							<br />
							сбор;
							<br />
							запись;
							<br />
							систематизацию;
							<br />
							накопление;
							<br />
							хранение;
							<br />
							уточнение (обновление, изменение);
							<br />
							извлечение;
							<br />
							использование;
							<br />
							передачу (распространение, предоставление, доступ);
							<br />
							обезличивание;
							<br />
							блокирование;
							<br />
							удаление;
							<br />
							уничтожение.
							<br />
						</p>
						<p>
							1.1.7. Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо,
							самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных
							данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих
							обработке, действия (операции), совершаемые с персональными данными;
						</p>
						<p>
							1.1.8. Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или
							определяемому Пользователю веб-сайта https://musicabinet.com/;
						</p>
						<p>1.1.9. Пользователь – любой посетитель веб-сайта https://musicabinet.com/;</p>
						<p>
							1.1.10. Предоставление персональных данных – действия, направленные на раскрытие персональных данных
							определенному лицу или определенному кругу лиц;
						</p>
						<p>
							1.1.11. Распространение персональных данных – любые действия, направленные на раскрытие персональных
							данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными
							данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой
							информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к
							персональным данным каким-либо иным способом;
						</p>
						<p>
							1.1.12. Трансграничная передача персональных данных – передача персональных данных на территорию
							иностранного государства органу власти иностранного государства, иностранному физическому или иностранному
							юридическому лицу;
						</p>
						<p>
							1.1.13. Уничтожение персональных данных – любые действия, в результате которых персональные данные
							уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в
							информационной системе персональных данных и (или) уничтожаются материальные носители персональных данных.
						</p>

						<h4>ПРЕДМЕТ ПОЛИТИКИ</h4>

						<p>
							2.1. Политика в отношении обработки персональных данных у ООО «Мьюзикабинет» (далее – Политика) определяет
							любое действие (операцию) или совокупность действий (операций), по сбору, записи, систематизации,
							накоплению, хранению, уточнению (обновлению, изменению), извлечению, использованию, передаче
							(распространение, предоставление, доступ), обезличиванию, блокированию, удалению, уничтожению персональных
							данных, а также сведения о реализуемых требованиях к защите персональных данных.
						</p>
						<p>
							2.2. Настоящая Политика конфиденциальности устанавливает обязательства Оператора по неразглашению и
							обеспечению режима защиты конфиденциальности персональных данных, которые Пользователь предоставляет по
							запросу Оператора при использовании сайта и/или услуги.
						</p>
						<p>
							2.3. Политика разработана в соответствии с действующим законодательством РФ и обработка персональных
							данных основана на следующих нормативных правовых актах:
							<br />
							Конституции Российской Федерации;
							<br />
							Федерального закона от 27 июля 2006 года № 152-ФЗ «О персональных данных»;
							<br />
							Федерального закона «Об информации, информационных технологиях и о защите информации» от 27.07.2006 №
							149-ФЗ.
							<br />
							Постановление Правительства РФ от 15.09.2008 №687 «Об утверждении Положения об особенностях обработки
							персональных данных, осуществляемой без использования средств автоматизации».
							<br />
							Постановление Правительства РФ от 01.11.2012 №1119 «Об утверждении требований к защите персональных данных
							при их обработке в информационных системах персональных данных».
							<br />
							Приказ ФСТЭК России от 18.02.2013 №21 (ред. от 14.05.2020) «Об утверждении состава и содержания
							организационных и технических мер по обеспечению безопасности персональных данных при их обработке в
							информационных системах персональных данных»;
							<br />
							Приказ Роскомнадзора от 05.09.2013 №996 «Об утверждении требований и методов по обезличиванию персональных
							данных»;
							<br />
							Иные нормативные правовые акты Российской Федерации и нормативные документы уполномоченных органов
							государственной власти.
							<br />
						</p>
						<p>
							2.4. Оператор может обрабатывать следующие персональные данные Пользователя:
							<br />
							- Фамилия, имя, отчество;
							<br />
							- Номер телефона;
							<br />
							- Адрес электронной почты;
							<br />
							- Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с
							помощью сервисов интернет-статистики (Яндекс Метрика, Гугл Аналитика и других).
							<br />
						</p>
						<p>
							2.5. Вышеперечисленные данные далее по тексту Политики объединены общим понятием «Персональные данные».
						</p>
						<p> 2.6. Оператор не осуществляет обработку биометрических персональных данных.</p>

						<h4>ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h4>

						<p>3.1. Персональные данные обрабатываются Оператором в следующих целях:</p>
						<p>3.1.1. соблюдение законности обработки персональных данных;</p>
						<p>
							3.1.2. осуществление и выполнение возложенных законодательством Российской Федерации на Оператора функций,
							полномочий и обязанностей, в частности:
							<br />
							- ведение текущего бухгалтерского и налогового учёта, формирование, изготовление и своевременная подача
							бухгалтерской, налоговой и статистической отчётности;
							<br />
							- выполнение требований законодательства по определению порядка обработки и защиты персональных данных
							граждан, являющихся клиентами Оператора.
							<br />
							- подтверждения достоверности и полноты персональных данных, предоставленных Пользователем;
							<br />
							- предоставления Пользователю эффективной клиентской и технической поддержки при возникновении проблем,
							связанных с использованием Сайта;
							<br />
							- Осуществления рекламной деятельности с согласия Пользователя.
							<br />
							- установления с Пользователем обратной связи, включая направление уведомлений, запросов, касающихся
							использования сайта https://musicabinet.com/, обработки запросов и заявок от Пользователя;
							<br />
							- определения места нахождения Пользователя для обеспечения безопасности, предотвращения мошенничества;
							<br />
							- предоставления Пользователю эффективной клиентской и технической поддержки при возникновении проблем,
							связанных с использованием Сайта https://musicabinet.com/ и/или в процессе получения товара и/или услуг
							Оператора.
							<br />
							- в иных законных целях.
							<br />
						</p>

						<h4>ПОРЯДОК СБОРА, ХРАНЕНИЯ, ПЕРЕДАЧИ И ИНЫХ ВИДОВ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ. </h4>

						<p>
							4.1. Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации
							правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований
							действующего законодательства в области защиты персональных данных.
						</p>
						<p>
							4.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам без
							согласия Пользователя, за исключением случаев, связанных с исполнением действующего законодательства.
							<br />
							Оператор осуществляет обработку персональных данных для каждой цели их обработки следующими способами:
							<br />
							- неавтоматизированная обработка персональных данных;
							<br />
							- автоматизированная обработка персональных данных с передачей полученной информации по
							информационно-телекоммуникационным сетям или без таковой;
							<br />
							- смешанная обработка персональных данных.
							<br />
							Оператор имеет право поручить обработку персональных данных другому лицу с согласия субъекта персональных
							данных, если иное не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора.
							Лицо, осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать принципы и
							правила обработки персональных данных, предусмотренные Законом о персональных данных, соблюдать
							конфиденциальность персональных данных, принимать необходимые меры, направленные на обеспечение выполнения
							обязанностей, предусмотренных Законом о персональных данных.
							<br />
							К обработке персональных данных допускаются работники Оператора, в должностные обязанности которых входит
							обработка персональных данных.
							<br />
							В случае выявления неточностей в персональных данных, Пользователь может актуализировать их
							самостоятельно, путем направления Оператору уведомления на адрес электронной почты Оператора
							support@musicabinet.com с пометкой «Актуализация персональных данных».
							<br />
							Срок обработки персональных данных является неограниченным. Пользователь может в любой момент отозвать
							свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной
							почты на электронный адрес Оператора support@musicabinet.com с пометкой «Отзыв согласия на обработку
							персональных данных».
							<br />
							Оператор прекращает обработку персональных данных в следующих случаях:
							<br />
							-выявлен факт их неправомерной обработки. Срок - в течение трех рабочих дней с даты выявления;
							<br />
							- достигнута цель их обработки;
							<br />
							- отозвано согласие субъекта персональных данных на обработку указанных данных, когда по Закону о
							персональных данных обработка этих данных допускается только с согласия.
							<br />
							При достижении целей обработки персональных данных, а также в случае отзыва субъектом персональных данных
							согласия на их обработку Оператор прекращает обработку этих данных, если:
							<br />
							- иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем по которому
							является субъект персональных данных;
							<br />
							- Оператор не вправе осуществлять обработку без согласия субъекта персональных данных на основаниях,
							предусмотренных Законом о персональных данных или иными федеральными законами;
							<br />
							- иное не предусмотрено другим соглашением между Оператором и субъектом персональных данных.
							<br />
							Оператор обеспечивает Пользователю возможность определить перечень персональных данных, указанной в
							согласии на обработку персональных данных, разрешенных субъектом персональных данных для распространения.
							<br />
						</p>

						<h4>ТРАНСГРАНИЧНАЯ ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ</h4>

						<p>
							5.1. Оператор до начала осуществления трансграничной передачи персональных данных обязан убедиться в том,
							что иностранным государством, на территорию которого предполагается осуществлять передачу персональных
							данных, обеспечивается надежная защита прав субъектов персональных данных.
						</p>
						<p>
							5.2. Трансграничная передача персональных данных на территории иностранных государств, не отвечающих
							вышеуказанным требованиям, может осуществляться только в случае наличия согласия в письменной форме
							субъекта персональных данных на трансграничную передачу его персональных данных и/или исполнения договора,
							стороной которого является субъект персональных данных.
						</p>

						<h4>МЕРЫ ЗАЩИТЫ ПЕРСОНАЛЬНЫХ ДАННЫХ.</h4>

						<p>
							6.1. Основными мерами защиты персональных данных, используемыми Оператором, являются:
							<br />
							назначение лица ответственного за обработку персональных данных;
							<br />
							определение актуальных угроз безопасности персональных данных при их обработке в информационных системах
							персональных данных, и разработка (совершенствование) мер и мероприятий по защите персональных данных;
							<br />
							разработка политики в отношении обработки персональных данных;
							<br />
							установление правил доступа к персональным данным, обрабатываемым в информационных системах персональных
							данных, а также обеспечения регистрации и учета всех действий, совершаемых с персональными данными в
							информационных системах персональных данных;
							<br />
							учет лиц, получивших доступ к обрабатываемым персональным данным, и (или) лиц, которым такая информация
							была предоставлена или передана;
							<br />
						</p>
						<p>
							6.2. Меры защиты персональных данных при их обработке техническими средствами устанавливаются в
							соответствии с требованиями Положения об обеспечении безопасности персональных данных при их обработке в
							информационных системах персональных данных (утверждено Постановлением Правительства РФ от 1 ноября 2012
							г. N 1119 «Об утверждении требований к защите персональных данных при их обработке в информационных
							системах персональных данных»), Специальных требований и рекомендаций по технической защите
							конфиденциальной информации, требований к составу и содержанию организационных и технических мер по
							обеспечению безопасности персональных данных при их обработке в информационных системах персональных
							данных (утверждены Приказом Федеральной службы по техническому и экспортному контролю от 18 февраля 2013
							г. N 21 «Об утверждении Состава и содержания организационных и технических мер по обеспечению безопасности
							персональных данных при их обработке в информационных системах персональных данных»).
						</p>
						<p>
							6.3. Меры по обеспечению защиты персональных данных признаются разумно достаточными, если исключается
							доступ к обрабатываемым персональным данным любых лиц без согласия их обладателя, а также обеспечивается
							обработка персональных данных без нарушения установленного режима защиты.
						</p>

						<h4>ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h4>

						<p>
							7.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его
							персональных данных, обратившись к Оператору с помощью электронной почты support@musicabinet.com.
						</p>
						<p>
							7.2. Оператор вправе вносить изменения в настоящую Политику конфиденциальности без согласия Пользователя.
						</p>
						<p>
							7.3. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором.
							Политика действует бессрочно до замены ее новой версией. Новая Политика конфиденциальности вступает в силу
							с момента ее размещения на Сайте, если иное не предусмотрено новой редакцией Политики конфиденциальности.
						</p>
						<p>
							7.4. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его
							персональных данных, обратившись к Оператору с помощью электронной почты support@musicabinet.com ли
							обратившись по другим каналам для связи, размещенным на Сайте Оператора.
						</p>
						<p>
							7.5. Все предложения или вопросы касательно настоящей Политики конфиденциальности следует сообщать по
							адресу: support@musicabinet.com или по другим каналам для связи, размещенным на Сайте Оператора.
						</p>
						<p>
							7.6. Настоящая Политика может быть пересмотрена в любом из следующих случаев:
							<br />
							при изменении законодательства Российской Федерации в области обработки и защиты ПДн;
							<br />
							в случаях получения предписаний на устранение несоответствий, затрагивающих область действия Политики;
							<br />
							по решению Оператора;
							<br />
							при изменении целей обработки ПДн;
							<br />
							при изменении организационной структуры, структуры информационных и/или телекоммуникационных систем (или
							введении новых);
							<br />
							при применении новых технологий обработки ПДн (в т.ч. передачи, хранения);
							<br />
							при появлении необходимости в изменении процесса обработки ПДн, связанной с деятельностью Оператора.
							<br />
						</p>
						<p>
							7.7. Неотъемлемой частью настоящей Политики конфиденциальности является:
							<br />
							Форма согласия субъекта персональных данных на их обработку..
							<br />
							Наш сайт использует cookie
							<br />
							Мы используем файлы cookie и похожие технологии, чтобы гарантировать максимальное удобство пользователям,
							предоставляя персонализированную информацию, запоминая предпочтения в области маркетинга и продукции, а
							также помогая получить правильную информацию. При использовании данного сайта, вы подтверждаете свое
							согласие на использование файлов cookie в соответствии с настоящим уведомлением в отношении данного типа
							файлов.
						</p>
					</Container>
				)}

				{settingsStore.lang !== "ru" && (
					<Container>
						<Title>Privacy Policy</Title>

						<Content>
							<h4>SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?</h4>

							<p>
								When you purchase something from our store, as part of the buying and selling process, we collect the
								personal information you give us such as your name, address and email address. When you browse our
								store, we also automatically receive your computer’s internet protocol (IP) address in order to provide
								us with information that helps us learn about your browser and operating system. Email marketing (if
								applicable): occasionally we may be sending you emails about our service, new products and other
							</p>

							<h4>SECTION 2 - CONSENT</h4>
							<p>
								How do we get your consent? When you provide us with your personal information to complete a
								transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we
								imply that you consent to our collecting your data and using it for that specific reason only. If we ask
								for your personal information for a secondary reason, like marketing, we will either ask you directly
								for your expressed consent, or provide you with an opportunity to say no. How do you withdraw your
								consent? If after you opt-in, you change your mind, you may withdraw your consent for us to contact you,
								for the continued collection, use or disclosure of your information, at anytime, by contacting us at
								info@musicabinet.com.
							</p>

							<h4>SECTION 3 - DISCLOSURE</h4>
							<p>
								We may disclose your personal information if we are required to do so by the lay or if you violate our
								Terms of Service.
							</p>

							<h4>SECTION 4 – ONLINE STORE</h4>
							<p>
								Our store is hosted on our internal servers.​Your data is stored under 256 bit SSL encryption behind a
								firewall. ​Payment: If you choose a direct payment gateway to complete your purchase the transaction
								operators may collect your credit card data and store them according to their internal policies.
								Important Note: we are not in any way affiliated with the transaction operators and do not carry any
								responsibility for services’ operations, policies, and/or malfunctions. All the transactions are
								encrypted through the Payment Card Industry Data Security Standards (PCI-DSS). Your purchase transaction
								data is only stored as long as it is necessary to complete your purchase transaction. After that is
								complete, your purchase transaction information is deleted. ​All direct payment gateways adhere to the
								standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of
								brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure
								handling of credit card information by our store and its service providers. For more insight, you may
								also want to read transaction operators’ Terms of Service or Privacy Statements.
							</p>

							<h4>SECTION 5 - THIRD-PARTY SERVICES</h4>
							<p>
								In general, the third-party providers used by us will only collect, use and disclose your information to
								the extent necessary to allow them to perform the services they provide to us.​ However, certain
								third-party service providers, such as payment gateways and other payment transaction processors, have
								their own privacy policies in respect to the information we are required to provide to them for your
								purchase-related transactions.​ For these providers we recommend that you read their privacy policies so
								you can understand the manner in which your personal information will be handled by these providers. ​In
								particular, remember that certain providers may be located in or have facilities that are located in a
								different jurisdiction than either you or us. So if you select to proceed with a transaction that
								involves the services of a third-party service provider then your information may become subject to the
								laws of the jurisdiction(s) in which that service provider or its facilities are located.​ As an
								example, if you are located in Canada and your transaction is processed by a payment gateway located in
								the United States, then your personal information used in completing that transaction may be subject to
								disclosure under United States legislation, including the Patriot Act.​ Once you leave our store’s
								website or are redirected to a third-party website or application, you are no longer governed by this
								Privacy Policy or our website’s Terms of Service. ​Links when you click on links on our store may
								redirect you away from our site. We are not responsible for the privacy practices of other sites and
								encourage you to read their privacy statements.​
							</p>

							<h4>SECTION 6 - SECURITY</h4>
							<p>
								​To protect your personal information, we take reasonable precautions and follow industry’s best
								practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or
								destroyed.​ If you provide us with your credit card information, the information is encrypted using
								secure socket layer technology (SSL) and stored with a AES-256 encryption. Although no method of
								transmission over the Internet or electronic storage is 100% secure, we follow all PCI-DSS requirements
								and implement additional generally accepted industry standards.
							</p>

							<h4>SECTION 7 - AGE OF CONSENT</h4>
							<p>
								​By using this site, you represent that you are at least the age of majority in your state or province
								of residence, or that you are the age of majority in your state or province of residence and you have
								given us your consent to allow any of your minor dependents to use this site.​
							</p>

							<h4>SECTION 8 - CHANGES TO THIS PRIVACY POLICY</h4>
							<p>
								We reserve the right to modify this privacy policy at any time, so please review it regularly. Changes
								and clarifications will take effect immediately upon their posting on the website. If we make material
								changes to this policy, we will notify you here that it has been updated as well as over email you have
								provided, so that you are aware of what information we collect, how we use it, and under what
								circumstances, if any, we use and or disclose it. ​If our store is acquired or merged with another
								company, your information may be transferred to the new owners so that we may continue to sell products
								to you.
							</p>

							<h4>QUESTIONS AND CONTACT INFORMATION</h4>
							<p>
								​If you would like to access, correct, amend or delete any personal information we have about you,
								register a complaint, or simply want more information contact us at info@musicabinet.com.
							</p>
						</Content>
					</Container>
				)}
			</ContactPageContainer>
		</>
	);
});
